let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5b7z5")).then(() => parcelRequire('gaBfD'));